<script setup>
import ImoSkeleton from './ImoSkeleton.vue'

defineProps({
  lines: {
    type: Number,
    default: 3,
  },
  lineHeight: {
    type: String,
    default: '0.875rem',
  },
  lastLineWidth: {
    type: String,
    default: '60%',
  },
})
</script>

<template>
  <div class="flex w-full flex-col gap-2">
    <ImoSkeleton
      v-for="line in lines"
      :key="line"
      :height="lineHeight"
      :width="line === lines && lines > 1 ? lastLineWidth : '100%'"
    />
  </div>
</template>
